import { render, staticRenderFns } from "./RequirementsAnalysis.vue?vue&type=template&id=d647e624&"
import script from "./RequirementsAnalysis.vue?vue&type=script&lang=js&"
export * from "./RequirementsAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports